import { PREFIX } from '../config'
import ColumnManager from '../util/column-manager'
import { TableProps } from '../util/default-props'
import Empty from '../../fe-table/components/empty/index'
import TableHeader from './trow/trow.vue'
import { Horizontal, Vertical } from './scroll'
import resizeObserverMixin from '../mixin/resize-observer'
import tableTbody from './tbody/table-tbody'
import VerticalList from '../util/vertical-list'
import '../index.scss'
// 基础表格
export default {
  name: 'SyTable',
  provide () {
    return { table: this }
  },
  mixins: [resizeObserverMixin],
  props: {
    ...TableProps,
    // height: {
    //   type: Number,
    //   default: () => 600
    // },
    customSlots: [Object],
    expandColumn: [Object]
  },
  computed: {
    className () {
      let className = `${PREFIX}-warp ${PREFIX}`
      if (this.border) {
        className += ` ${PREFIX}-bordered`
      }
      return className
    }
  },
  data () {
    return {
      fixedColumnsHeadRowsHeight: 0,
      computeFinish: false, // 第一遍渲染只渲染表头
      style: {
        display: 'block',
        scrollWidth: 0
      },
      // height
      startIndex: 0,
      endIndex: 0,
      fiexdBoxShadowLeft: false,
      fiexdBoxShadowRight: true
    }
  },
  created () {
    this.curRefs = Object.create(null)
    this.columnManager = new ColumnManager(this.columns)
    this.prefix = PREFIX
    this.rightColumnsWidth = this.columnManager.rightColumnsWidth() || 100
    this.leftColumnsWidth = this.columnManager.leftColumnsWidth() || 100
  },
  mounted () {
    // 更新高度
    this.createdResizeObserver((entry) => {
      if (!this.$ready) { return }
      let width = this.columnManager.columnsWidth()
      if (entry.contentRect.width !== 0 && entry.contentRect.width !== width) {
        this.updateTable()
      }
    })
    this.$ready = true
  },
  updated () {

  },
  methods: {
    // 对外强制刷新
    resetForceUpdate () {
      this.updateTable()
    },
    // 更新宽度
    updateTable () {
      // 获取当前盒宽度
      if (!this.dom) {
        const dom = this.curRefs['tableHead'].$el
        this.dom = dom
      }
      const {height, width} = this.dom.getBoundingClientRect()
      const scrollWidth = this.dom?.scrollWidth
      this.style.height = height
      this.style.width = width
      this.style.scrollWidth = scrollWidth
      this.dom.style.width = scrollWidth
      this.dom.style.height = height
      this.computeFinish = true
    },
    // 更新heard
    updateHeard (scrollWidth, width, rightColumnsWidth, leftColumnsWidth) {
      this.curRefs['tableHead'].updateHead()
      // 更新 tableHead 宽度，预留固定列宽度
      if (scrollWidth > width) {
        this.curRefs['tableHead'].$el.style.paddingRight = (scrollWidth - width - leftColumnsWidth) + 'px'
        this.curRefs['tableHead'].$el.style.paddingLeft = leftColumnsWidth + 'px'
      }
    },
    saveRef (name, node) {
      this.curRefs[name] = node
    },
    // 水平滚动
    handleHorizontalScroll (event) {
      const dom = this.curRefs['tableHead'].$el
      const bodyRefScroll = this.$refs.bodyRefScroll.$el
      if (dom === event.target) {
        bodyRefScroll.scrollLeft = event.target.scrollLeft
      } else {
        dom.scrollLeft =  event.target.scrollLeft
      }
      this.scrollLeft = event.target.scrollLeft
      if (dom.scrollWidth - dom.clientWidth === this.scrollLeft) {
        this.fiexdBoxShadowLeft = true
        this.fiexdBoxShadowRight = false
        return 
      }
      if (this.scrollLeft === 0) {
        this.fiexdBoxShadowLeft = false
        this.fiexdBoxShadowRight = true
      }
      if (this.scrollLeft > 0) {
        this.fiexdBoxShadowLeft = true
        this.fiexdBoxShadowRight = true
      }
    },
    // 横向滚动距离
    getWidthTransform () {

    },
    // 渲染中间table
    renderMainTable () {
      const content = (
        <div
          ref={`${PREFIX}-middle`} class={`${PREFIX}-middle`}>
          <div>
            {
              this.renderTable({ columns: this.columnManager.columns })
            }
          </div>
          <el-tooltip
            placement='top'
            ref='tooltip'
            content={this.tooltipContent}
          ></el-tooltip>
        </div>
      )
      return content
    },

    renderHorizontal (content) {
      return (
        <Horizontal
          onHorizontalScroll={this.handleHorizontalScroll} ref='bodyRefScroll'>
          {content}
        </Horizontal>
      )
    },
    // tbody
    renderTable ({ columns}) {

      const result = []
      if (this.computeFinish) {
        result.push(
          this.renderHorizontal(
            <div>
              <div style={{width: `${this.style.scrollWidth}px`}}></div>
              <tableTbody
                key='body'
                columnManager={this.columnManager}
                width={this.style.scrollWidth}
                // fixed={fixed}
                columns={columns}
                on={{
                  saveRef: this.saveRef
                }}
              />
            </div>
          )
        )
      }
      return result
    },
    // 暂无数据
    renderEmpty () {
      if (this.dataSource.length || this.loading) {
        return null
      }
      return this.customSlots?.empty || <Empty />
    },

    // loading
    renderLoading () {
      if (!this.loading) {
        return null
      }
      const loadingStyle = {}
      if (this.dataSource.length > 0) {
        loadingStyle.position = 'absolute'
        loadingStyle.top = `${this.fixedColumnsHeadRowsHeight}px`
      } else {
        loadingStyle.position = ''
        loadingStyle.top = 0
      }
      return (
        <div
          v-loading={this.loading}
          class={`${PREFIX}-loading`}
          style={loadingStyle}
        ></div>
      )
    },
    //虚拟滚动更新index
    updateData (startIndex, endIndex) {
      this.startIndex = startIndex
      this.endIndex  = endIndex

      // console.log('this.startIndex', this.startIndex)
      // console.log('this.endIndex', this.endIndex)
    }
  },
  render (h) {
    const { groupScroll = false, fiexdBoxShadowLeft, fiexdBoxShadowRight } = this
    return (
      <div
        class={{[this.className]: true, 'fiexd-box-shadow-left': fiexdBoxShadowLeft, 'fiexd-box-shadow-right': fiexdBoxShadowRight}}
      >
        <div
          class={{'table-heard-warp': true}}
        >
          <TableHeader
            key='head'
            columns={this.columnManager.columns}
            on={{
              saveRef: this.saveRef,
              scroll: this.handleHorizontalScroll
            }}
          />
        </div>
        {this.renderEmpty()}
        {this.renderLoading()}
        {this.dataSource.length > 0 && <VerticalList
          on={{
            updateData: this.updateData
          }}
          isVirtual={this.openVirtual.group}
          key={'tab-group-warp'}
          parentClass='sy-virtual-table-tbody'
          groupScroll={groupScroll}
          dataSource={this.dataSource}
          height={this.groupHeight.table}
          estimatedRowHeight={this.estimatedRowHeight}
          bufferSize={3}
          width={this.style.scrollWidth}
          dHeight={8}
          scopedSlots={{
            default: this.renderMainTable()
          }}
        >
        </VerticalList>}
      </div>
    )
  },
  components: {
    Empty,
    TableHeader,
    Vertical,
    Horizontal,
    tableTbody,
    VerticalList
  }
}
